module.exports = __webpack_public_path__ + "img/color-palette-mobile.dd13fd0b.png";